/** Scouting Report matrix scores; 1, 2, 3, 4, 4+ */
export enum ScoutingReportScore{
	Score1=1,
	Score2=2,
	Score3=3,
	Score4=4,
	Score4Plus=5,
}
export const ScoutingReportScoreValues = [1,2,3,4,5];